<template>
  <a-form-item
    :wrapper-col="buttonItemLayout.wrapperCol"
    :style="styled"
  >
    <a-button type="primary" shape="round" size="large" @click="() => { $emit('submit') }">{{btn_text}}</a-button>
  </a-form-item>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  data() {
    return {

    };
  },
  mixins: [formLayoutMixin],
  props: {
    styled: {
      type: String,
      default: "margin-top:0.5em; padding-left:4em;"
    },
    formLayout: {
      type: String,
      default: "horizontal"
    },
    btn_text: {
      type: String,
      default: "Update Details"
    }
  }
};
</script>